module.exports = __webpack_public_path__ + "images/digitin-icon.edc9c73dc977a13bfa865b0032836539.svg";